import { audioService } from "../services/audioService";

import { wordService } from "../services/wordService";
import { grammerLawService } from "../services/grammerLawService";
import { articleService } from "../services/articleService";
import { courseService } from "../services/courseService";
import { userService } from "../services/userService";
export default {
  state: {
    mistakes: [],
    words: [],
    videos: [],
    audios: [],
    grammarLaws: [],
    chapters: [],
    faq: [],
    externals: [],
    payment_options: [],
    word_groups: [],
    word_groups_words: [],
    course: [],
    bigCourse: {},
    articles: [],
    currentGame: {},
    chaptersProgress: {},
    totalProgress: 0,
    nextLesson: {},
    nextChapter: {},
  },
  getters: {
    mistakes(state) {
      return state.mistakes;
    },
    bigCourse(state) {
      return state.bigCourse;
    },
    faq(state) {
      return state.faq;
    },
    word_groups(state) {
      return state.word_groups;
    },
    word_groups_words(state) {
      return state.word_groups_words;
    },
    externals(state) {
      return state.externals;
    },
    payment_options(state) {
      return state.payment_options;
    },
    words(state) {
      return state.words;
    },
    videos(state) {
      return state.videos;
    },
    audios(state) {
      return state.audios;
    },
    grammarLaws(state) {
      return state.grammarLaws;
    },
    chapters(state) {
      return state.chapters;
    },
    course(state) {
      return state.course;
    },
    nextLesson(state) {
      return state.nextLesson;
    },
    nextChapter(state) {
      return state.nextChapter;
    },

    articles(state) {
      return state.articles;
    },
    chaptersProgress(state) {
      return state.chaptersProgress;
    },
    totalProgress(state) {
      return state.totalProgress;
    },
    currentGame(state) {
      return state.currentGame;
    }
  },
  mutations: {
    setMistakes(state, { word }) {
      state.mistakes = [...state.mistakes, word];
    },
    bigCourse(state, { bigCourse }) {
      state.bigCourse = bigCourse;
    },
    setNextLesson(state, nextLesson) {
      // console.log(nextLesson);
      state.nextLesson = nextLesson;
    },
    setNextChapter(state, nextChapter) {
      state.nextChapter = nextChapter;
    },
    setWords(state, { words }) {
      state.words = words;
    },
    setVideos(state, { videos }) {
      state.videos = videos;
    },
    setAudios(state, { audios }) {
      state.audios = audios;
    },
    setFaq(state, { faq }) {
      state.faq = faq;
    },
    setExternals(state, { externals }) {
      state.externals = externals;
    },
    setPaymentOptions(state, { payment_options }) {
      state.payment_options = payment_options;
    },
    setWordGroups(state, { word_groups }) {
      state.word_groups = word_groups;
    },
    setWordGroupsWords(state, word_groups_words) {
      state.word_groups_words = word_groups_words;
    },
    setGrammerLaws(state, { grammarLaws }) {
      state.grammarLaws = grammarLaws;
    },
    setChapters(state, { chapters }) {
      state.chapters = chapters;
    },
    setCourse(state, { course }) {
      state.course = course;
    },
    setArticles(state, { articles }) {
      state.articles = articles;
    },
    setChaptersProgress(state, { chaptersProgress }) {
      state.chaptersProgress = chaptersProgress;
    },
    setTotalProgress(state, { totalProgress }) {
      state.totalProgress = totalProgress;
    },
    setCurrentGame(state, { lesson, courseId, courseName }) {
      state.currentGame = { lesson, courseId, courseName };
    }
  },
  actions: {
    async initData({ commit }, { user }) {
      let words = [];
      let audios = [];
      let videos = [];
      let grammarLaws = [];
      let chapters = [];
      let course = [];
      let articles = [];
      let faq = [];
      let bigCourse = {};
      let externals = [];
      let payment_options = [];
      let word_groups = [];
      let word_groups_words = [];
      let nextLesson = {};
      let nextChapter = {};
      //course test
      try {
        course = await courseService.getCourse();

        commit({ type: "setCourse", course });
      } catch (err) {
        console.log({ err });
      }
      // try {
      //   nextLesson = await userService.nextLesson(user);
      //   commit({ type: "setNextLesson", nextLesson });
      // } catch (err) {
      //   console.log({ err });
      // }
      try {
        words = await wordService.getWords(user);
        commit({ type: "setWords", words });
      } catch (err) {
        console.log({ err });
      }
      try {
        bigCourse = await courseService.getAllData();

        faq = bigCourse.faqs;
        externals = bigCourse.external_sections;
        payment_options = bigCourse.payments_options;
        word_groups = bigCourse.word_groups;

        commit({ type: "bigCourse", bigCourse });
        commit({ type: "setFaq", faq });
        commit({ type: "setExternals", externals });
        commit({ type: "setPaymentOptions", payment_options });
        commit({ type: "setWordGroups", word_groups });
      } catch (err) {
        console.log({ err });
      }
      try {
        videos = await courseService.getVideos();
        commit({ type: "setVideos", videos });
      } catch (err) {
        console.log({ err });
      }
      try {
        grammarLaws = await grammerLawService.getGrammerLaws();
        commit({ type: "setGrammerLaws", grammarLaws });
      } catch (err) {
        console.log({ err });
      }

      try {
        articles = await articleService.getArticles();
        commit({ type: "setArticles", articles });
      } catch (err) {
        console.log({ err });
      }
    }
    // async setWords({ commit }, { user }) {
    //     try {
    //         const words = await wordService.getWords(user)

    //         commit({ type: 'setWords', words })
    //     } catch (err) {
    //         console.log(err);
    //     }
    // },

    // async setAudios({ commit }) {
    //     try {
    //         const audios = await audioService.getAudios()
    //         commit({ type: 'setAudios', audios })
    //     } catch (err) {
    //         console.log(err);
    //     }
    // },
    // async setGrammerLaws({ commit }, { user }) {
    //     try {
    //         const grammarLaws = await grammerLawService.getGrammerLaws(user)
    //         commit({ type: 'setGrammerLaws', grammarLaws })
    //     } catch (err) {
    //         console.log(err);
    //     }
    // },
  }
};



// WEBPACK FOOTER //
// ./src/store/game.store.js